/**
 * ViewTabs Component
 * Pro Tools-inspired tab toggle between Edit and Mix views
 */
import { motion } from 'framer-motion';
import { Layers, Sliders } from 'lucide-react';
import { cn } from '../../../lib/utils';

export const ViewTabs = ({ activeView, onViewChange, className }) => {
  const tabs = [
    { id: 'edit', label: 'Edit', icon: Layers, shortcut: '⌘1' },
    { id: 'mix', label: 'Mix', icon: Sliders, shortcut: '⌘2' },
  ];
  
  return (
    <div 
      className={cn(
        "flex items-center bg-zinc-800/80 rounded-lg p-1 backdrop-blur-sm",
        className
      )}
      data-testid="view-tabs"
    >
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeView === tab.id;
        
        return (
          <button
            key={tab.id}
            onClick={() => onViewChange(tab.id)}
            className={cn(
              "relative flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all",
              isActive 
                ? "text-white" 
                : "text-zinc-400 hover:text-zinc-200"
            )}
            data-testid={`view-tab-${tab.id}`}
            title={`${tab.label} View (${tab.shortcut})`}
          >
            {/* Active background */}
            {isActive && (
              <motion.div
                className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-indigo-500/20 rounded-md border border-cyan-500/30"
                layoutId="activeViewTab"
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
              />
            )}
            
            <Icon className={cn(
              "w-4 h-4 relative z-10",
              isActive && "text-cyan-400"
            )} />
            <span className="relative z-10">{tab.label}</span>
            
            {/* Keyboard shortcut hint */}
            <span className={cn(
              "text-[10px] relative z-10 ml-1 opacity-50",
              isActive ? "text-cyan-300" : "text-zinc-500"
            )}>
              {tab.shortcut}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default ViewTabs;
